import { Section } from "./shared";

export default function ExecutableCandidate() {
  return <Section stage="Stage 4 — Evaluate Executability" title="Executable Candidate Readiness">
    <p className="text-sm font-medium text-slate-900">No executable candidate is selected on this page.</p>
    <p className="mt-2 text-sm text-slate-600">Management constraints have not been applied yet, so the evidence stays analytical until Management evaluates it in Portfolio Capital Strategy.</p>
  </Section>;
}
